import { render } from "./OrdersInfo.vue?vue&type=template&id=4b355514&scoped=true"
import script from "./OrdersInfo.vue?vue&type=script&lang=js"
export * from "./OrdersInfo.vue?vue&type=script&lang=js"

import "./OrdersInfo.vue?vue&type=style&index=0&id=4b355514&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b355514"]])

export default __exports__